import React, { useCallback, useEffect, useState } from "react";
import {ToastContainer, Toast, Modal, Row, Col, Button, OverlayTrigger, Tooltip} from "react-bootstrap";
import { Container } from "react-bootstrap";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { useLoader } from "../../context/LoaderContext";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "../../assets/styles/src/container/pages/dashboard.css";
import DashboardCard from "../../components/dashboard-card";
// import { NpaPropertiesCard } from "../../components/Data";
import {deleteNpaProperties, npaPropertiesList, propertyTypesDropdown, reqToGetFilterData, reqToImportNpaProperties} from "../../redux/slice/propertySlice";
import PropertyList from "./PropertyList";
import DeletePopup from "../../components/delete-popup";
import {Cancel01Icon, CheckmarkBadge04Icon, Delete02Icon, InformationCircleIcon} from "../../assets/icons";
import CommonPagination from "../../components/commonPagination";
import { mapToSelectOptions } from "../../components/common";
// import ImportModal from "./ImportModal";
import AllProperty from "../../assets/images/npa-properties/all-property-icon.png";
import ExpiredProperty from "../../assets/images/npa-properties/expired-property.png";
import LiveProperty from "../../assets/images/npa-properties/live-property-icon.png";
import UpcomingProperty from "../../assets/images/npa-properties/upcoming-property.png";
import Select from 'react-select';
import CommonFormLabel from "../../components/formLabel";
import CommonButton from "../../components/commonButton";


const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const location = useLocation();
  const { setLoading } = useLoader();

  const {total,properties,statusCounts} = useSelector((state) => state?.property?.propertyList);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarVariant, setSnackbarVariant] = useState("toast-success");
  // Toast
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Delete Property, Modal state
  const [openDeletePropertyModal, setOpenDeletePropertyModal] = useState(false);
  const [selectedDeleteProperty, setSelectedDeleteProperty] = useState(null);
  // Card Status
  const [cardStatus, setCardStatus] = useState("");
  // Add or Edit Form
  const [isEdit, setIsEdit] = useState(false);
  // Pagination
  const [limit, setLimit] = useState({ value: 10, label: 10 });
  const [currentPage, setCurrentPage] = useState(1);
  // Open Import NPA Properties Modal
  const [openImportModal, setOpenImportModal] = useState(false);
  // Filter Modal State
  const [filterModal, setFilterModal] = useState(false);
  // search & Filter
  const [filterValues,setFilterValues] = useState({search:"",asset:"",property:"",possession:"",city:"",reservePrice:""})
  const [assetOptions,setAssetOptions] = useState();
  const [propertyOptions,setPropertyOptions] = useState();
  const [possessionOptions,setPossessionOptions] = useState();
  const [cityOptions,setCityOptions] = useState();
  const [reservePriceOptions,setReservePriceOptions] = useState();

  const [dropdownData, setDropdownData] = useState({
    propertyTypes: [],
    assetCategories: [],
    possessionTypes: [],
    auctionTypes: [],
  });

  // console.log("currentPage",currentPage);
  

  // console.log("statusCounts",statusCounts,"total",total);

  const NpaPropertiesCard = [
    {
      id: 1,
      total: statusCounts?.total || 0,
      title: "All Property",
      src: AllProperty,
      status: "",
    },
    {
      id: 2,
      total: statusCounts?.live || 0,
      title: "Live Property",
      src: LiveProperty,
      status: "live",
    },
    {
      id: 3,
      total: statusCounts?.upcoming || 0,
      title: "Upcoming Property",
      src: UpcomingProperty,
      status: "upcoming",
    },
    {
      id: 4,
      total: statusCounts?.expired || 0,
      title: "Expired Property",
      src: ExpiredProperty,
      status: "expired",
    },
  ];

  //  console.log("assetOptions",assetOptions,"propertyOptions",propertyOptions,"possessionOptions",possessionOptions,"cityOptions",cityOptions,"reservePriceOptions",reservePriceOptions);

// console.log("properties : : ",properties);

  useEffect(() => {
    const savedPage = sessionStorage.getItem('currentPageNo');
    if (savedPage) {
      setCurrentPage(parseInt(savedPage, 10));
      sessionStorage.removeItem('currentPageNo'); // Optional: Clear after use
    }

  }, []);

  useEffect(() => {
    dispatch(propertyTypesDropdown({})).then((res) => {
      if (res?.payload?.success === true) {
        const formattedData = {
          propertyTypes: res?.payload?.data?.propertyTypes?.map(item => item?.name),
          assetCategories: res?.payload?.data?.assetCategories?.map(item => item?.name),
          possessionTypes: res?.payload?.data?.possessionTypes?.map(item => item?.name),
          auctionTypes: res?.payload?.data?.auctionTypes.map(item => item?.name),
        };
        setDropdownData(formattedData);
      }
    });
  }, [dispatch])
  


  const handleToggleDropdown = (dropdownId) => {
    setOpenDropdown((prev) => (prev === dropdownId ? null : dropdownId));
  };

  const getCustomerActions = (item) => [
    {
      title: "Delete",
      handler: () => handlerDeleteProperty(item),
    },
  ];

  const handlerDeleteProperty = (item) => {
    setSelectedDeleteProperty(item);
    setOpenDeletePropertyModal(true);
  };

  const handleConfirmDelete = () => {
    try {
      setLoading(true);
      dispatch(deleteNpaProperties({ id: selectedDeleteProperty?.id })).then(
        (res) => {
          setSnackbarMessage(res?.msg || "Property deleted successfully");
          setSnackbarVariant("toast-success");
          setShowSnackbar(true);
          dispatch(npaPropertiesList({
            page: currentPage,
            status: cardStatus || "",})).then((res) => {
            setLoading(false);
            setIsSubmitting(false);
          })
        }
      );
    } catch (error) {
      setSnackbarMessage("Failed to delete Property");
      setSnackbarVariant("toast-danger");
      setShowSnackbar(true);
      setLoading(false);
    } 
    finally {
      setOpenDeletePropertyModal(false);
    }
  };

  // Pagination Handler
  const handlePageChange = (newPageNumber) => {
    setCurrentPage(newPageNumber);
  };

  // status handler based on Card Click (APi will get call and display list based on status)
  const handleCardClick = (value) => {
    setCardStatus(value);
    setCurrentPage(1);
    setFilterValues({
      asset: "",
      property: "",
      possession: "",
      city: "",
      reservePrice: "",
      search: "",
    })
  };   

  const handleEditBtn = (item) => {
    setIsEdit(true);
    navigate(`/npa-properties/edit/${item.id}`, {
      state: { item, isEdit: true },
    });
  };

  // Api Call for Search
  useEffect(() => {
    const delayTimeout = setTimeout(() => {
      dispatch(npaPropertiesList({ 
        page: currentPage,
        status: cardStatus || "",
        search: filterValues?.search,
        asset_category: filterValues?.asset,
        property_type: filterValues?.property,
        possession_type: filterValues?.possession,
        city_town: filterValues?.city,
        reserve_price: filterValues?.reservePrice,
       }));
    }, 2000); // 3 second delay

    // Cleanup function to clear the timeout if searchTerm changes before the delay
    return () => clearTimeout(delayTimeout);
  }, [filterValues, currentPage,cardStatus, dispatch]);

  const getAllBankNpaProperties = useCallback(() => {
    setLoading(true);
    // Perform both API calls simultaneously
    Promise.all([
      // First API call: dispatching npaPropertiesList
      dispatch(
        npaPropertiesList({
          // search: filterValues?.search,
          status: cardStatus || "",
          page: currentPage,
          limit: limit?.value,
          asset_category: filterValues?.asset,
          property_type: filterValues?.property,
          possession_type: filterValues?.possession,
          city_town: filterValues?.city,
          reserve_price: filterValues?.reservePrice,
        })
      ),

      // Second API call: reqToGetFilterData
      dispatch(reqToGetFilterData({})),
    ])
      .then(([_, filterDataResponse]) => {
        // Assuming reqToGetFilterData response has the desired data
        const data = filterDataResponse?.payload?.filters;

        // Update the states with API response data
        setAssetOptions(mapToSelectOptions(data?.asset_category) || []);
        setPropertyOptions(mapToSelectOptions(data?.property_type) || []);
        setPossessionOptions(mapToSelectOptions(data?.possession_type) || []);
        setCityOptions(mapToSelectOptions(data?.city_town) || []);
        setReservePriceOptions([
          {
            value: data?.reserve_price?.min || 0,
            label: `Min: ₹${data?.reserve_price?.min || 0}`,
          },
          {
            value: data?.reserve_price?.max || 0,
            label: `Max: ₹${data?.reserve_price?.max || 0}`,
          },
        ]);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [
    dispatch,
    // filterValues?.search,
    filterValues?.asset,
    filterValues?.property,
    filterValues?.possession,
    filterValues?.city,
    filterValues?.reservePrice,
    cardStatus,
    limit?.value,
    currentPage,
    setLoading,
  ]);

  useEffect(() => {
    getAllBankNpaProperties();
  }, [getAllBankNpaProperties]);

  // Open Import Modal
  const handleOpenImportModal = () => {
    setOpenImportModal(true);
  };

  // Close Import Modal
  const handleCloseImportModal = () => {
    setOpenImportModal(false);
    setCsvData("");
    setImportApiErr("");
    setCsvFileName("");
  };

    // Handler for downloading Sample CSV file
    // const downloadSampleCsvFile = (e) => {
    //   e.preventDefault();
    //   setLoading(true);
    //   const fileUrl = "/npaProperties.csv"; // Ensure this file is in the 'public' folder
    //   const link = document.createElement("a");
    //   link.href = fileUrl;
    //   link.setAttribute("download", "SampleTemplate(Npa-Properties).csv");
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    //   URL.revokeObjectURL(fileUrl); 
    //   setLoading(false);
    // }
    const downloadSampleCsvFile = async (e) => {
      e.preventDefault(); // Prevent default event behavior
      setLoading(true);
    
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Sample");
    
      // ✅ Dynamic dropdown values
      const optionsPropertyTypes = ["Select", ...dropdownData.propertyTypes];
      const optionsAssetCategories = ["Select", ...dropdownData.assetCategories];
      const optionsPossessionTypes = ["Select", ...dropdownData.possessionTypes];
      const optionsAuctionTypes = ["Select", ...dropdownData.auctionTypes];
    
      // ✅ Define headers
      const headers = [
        "asset_category", "property_type", "property_address", "province_state", "taluka", "city_town",
        "area_locality", "land_area", "builtup_carpet_area", "borrower_names", "possession_type",
        "reserve_price", "emd", "min_increment", "amount_outstanding", "dsc_required", "auction_type",
        "auction_start_time", "auction_end_time","description", "country", "contact_name",
        "contact_number", "time_extension", "application_submission_date", "property_inspection_datetime",
        "service_provider"
      ];
    
      // ✅ Add headers to the worksheet
      worksheet.addRow(headers);
    
      // ✅ Set column widths for better visibility
      worksheet.columns = headers.map(header => ({ header, key: header, width: 25 }));
    
      // ✅ Static values for other columns
      const staticValues = {
        property_address: "123 Main St",
        province_state: "Gujarat",
        taluka: "Varacha",
        city_town: "Surat",
        area_locality: "Katargam",
        land_area: "2000.00",
        builtup_carpet_area: "1500.00",
        borrower_names: "John Doe",
        reserve_price: "5000000.00",
        emd: "5000000.00",
        min_increment: "6000000.00",
        amount_outstanding: "8000000.00",
        dsc_required: "No",
        auction_start_time: "01/01/2025, 05:30 am",
        auction_end_time: "05/01/2020, 05:30 am",
        description: "Spacious house 3Bhk",
        country: "India",
        contact_name: "Manish Mehta",
        contact_number: "1234567890",
        time_extension: "10 min",
        application_submission_date: "06/01/2025, 05:30 am",
        property_inspection_datetime: "10/01/2025, 05:30 am",
        service_provider: "Mehta and Sons",
      };
    
      // ✅ Apply dropdowns & static values (Rows 2 to 10 only)
      for (let rowIndex = 2; rowIndex <= 10; rowIndex++) {
        const rowData = [];
    
        headers.forEach((header, index) => {
          if (header === "asset_category") {
            rowData[index] = "Select"; // Dropdown
          } else if (header === "property_type") {
            rowData[index] = "Select"; // Dropdown
          } else if (header === "possession_type") {
            rowData[index] = "Select"; // Dropdown
          } else if (header === "auction_type") {
            rowData[index] = "Select"; // Dropdown
          } else {
            rowData[index] = staticValues[header] || ""; // Static value
          }
        });
    
        worksheet.addRow(rowData);
    
        // ✅ Apply dropdown validation
        const assetCategoryCell = worksheet.getCell(`A${rowIndex}`);
        const propertyTypeCell = worksheet.getCell(`B${rowIndex}`);
        const possessionTypeCell = worksheet.getCell(`K${rowIndex}`);
        const auctionTypeCell = worksheet.getCell(`Q${rowIndex}`);
    
        assetCategoryCell.dataValidation = {
          type: "list",
          allowBlank: false,
          formulae: [`"${optionsAssetCategories.join(",")}"`],
        };
        propertyTypeCell.dataValidation = {
          type: "list",
          allowBlank: false,
          formulae: [`"${optionsPropertyTypes.join(",")}"`],
        };
        possessionTypeCell.dataValidation = {
          type: "list",
          allowBlank: false,
          formulae: [`"${optionsPossessionTypes.join(",")}"`],
        };
        auctionTypeCell.dataValidation = {
          type: "list",
          allowBlank: false,
          formulae: [`"${optionsAuctionTypes.join(",")}"`],
        };
    
        // ✅ Apply styling for better visibility
        [assetCategoryCell, propertyTypeCell, possessionTypeCell, auctionTypeCell].forEach(cell => {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFFFFF" }, // Light background
          };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
          cell.font = { bold: true, size: 12 };
        });
      }
    
      // ✅ Apply header styling
      worksheet.getRow(1).eachCell(cell => {
        cell.font = { bold: true, color: { argb: "000000" } };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFD3D3D3" }, // Light gray background
        };
        cell.alignment = { horizontal: "center" };
      });
    
      // ✅ Generate and download Excel file
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
    
      saveAs(blob, "SampleTemplate.xlsx");
  
      setLoading(false);
    };

  // const handleExportNpaProperties = () => {
  //   setLoading(true);
  //   dispatch(npaPropertiesList({ limit: 100000 }))
  //     .then((res) => {
  //       console.log("res : ", res?.payload?.properties);
  //       const properties = res?.payload?.properties;

  //       if (!properties || properties.length === 0) {
  //         setSnackbarMessage("No data available to Export");
  //         setSnackbarVariant("toast-success");
  //         setShowSnackbar(true);
  //         setLoading(false);
  //         return;
  //       }

  //       // Specify the fields to export
  //       const fieldsToExport = [
  //         "Bank.bank_name",
  //         "amount_outstanding",
  //         "application_submission_date",
  //         "area_locality",
  //         "asset_category",
  //         "auction_end_time",
  //         "auction_id",
  //         "auction_start_time",
  //         "auction_type",
  //         "bank_id",
  //         "borrower_names",
  //         "branch_id",
  //         "builtup_carpet_area",
  //         "city_town",
  //         "contact_name",
  //         "contact_number",
  //         "country",
  //         "createdAt",
  //         "created_at",
  //       ];

  //       // Utility function to convert snake case to camel case
  //       const toCamelCase = (str) => {
  //         return str
  //           .replace(/_/g, " ")
  //           .replace(/\w+/g, (word, index) =>
  //             index === 0
  //               ? word.charAt(0).toUpperCase() + word.slice(1)
  //               : word.charAt(0).toUpperCase() + word.slice(1)
  //           )
  //           .replace(/\s+/g, "");
  //       };

  //       console.log("toCamelCase",toCamelCase);

  //       // Convert headers to camel case
  //       const headers = fieldsToExport.map((field) => {
  //         if (field.includes(".")) {
  //           const [_, child] = field.split(".");
  //           return toCamelCase(child);
  //         }
  //         return toCamelCase(field);
  //       });

  //       console.log("headers : ",headers);

  //       // Extract the relevant data
  //       const filteredData = properties.map((property) => {
  //         const filteredObject = {};
  //         fieldsToExport.forEach((field) => {
  //           // Handle nested fields like "Bank.bank_name"
  //           if (field.includes(".")) {
  //             const [parent, child] = field.split(".");
  //             filteredObject[toCamelCase(child)] = property[parent]?.[child] || "";
  //           } else {
  //             filteredObject[toCamelCase(field)] = property[field] || "";
  //           }
  //         });
  //         return filteredObject;
  //       });

  //       console.log("filteredData : ", filteredData);

  //       // Convert data to CSV
  //       const csvContent = [
  //         headers.join(","), // Header row
  //         ...filteredData.map((row) =>
  //           headers.map((header) => row[header]).join(",")
  //         ),
  //       ].join("\n");

  //       console.log("csvContent : ", csvContent);

  //       // Create and download the CSV file
  //       const blob = new Blob([csvContent], { type: "text/csv" });
  //       const url = URL.createObjectURL(blob);
  //       const link = document.createElement("a");
  //       link.href = url;
  //       link.download = "filtered_properties.csv";
  //       link.click();

  //       // // Clean up the URL object
  //       URL.revokeObjectURL(url);
  //       dispatch(npaPropertiesList({ limit: 10 })).then(() => {
  //         setLoading(false);
  //       });
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching data:", error);
  //       setSnackbarMessage("Failed to fetch data for export");
  //       setSnackbarVariant("toast-error");
  //       setShowSnackbar(true);
  //       setLoading(false);
  //     });
  // };
  
  // Export Handler
  const handleExportNpaProperties = () => {
      try{
        setLoading(true);
        dispatch(npaPropertiesList({ 
          status: cardStatus || "", 
          limit: 100000, 
          search: filterValues?.search, 
          asset_category: filterValues?.asset,
          property_type: filterValues?.property,
          possession_type: filterValues?.possession,
          city_town: filterValues?.city,
          reserve_price: filterValues?.reservePrice, })).then((res) => {
            const data = res?.payload?.properties;
            // console.log("data",data);
            
            if (!data || data.length === 0) {
              setSnackbarMessage("No data available to Export");
              setSnackbarVariant("toast-success");
              setShowSnackbar(true);
              setLoading(false);
              return;
            }

            // Map the data for export
            const dataToExport = data?.map((item) => {
              return {
                borrower_names: item?.borrower_names || "-",
                property_type: item?.propertyType?.name || "-",
                asset_category: item?.assetCategory?.name || "-",
                land_area: item?.land_area || "-",
                builtup_carpet_area: item?.builtup_carpet_area || "-",
                dsc_required: item?.dsc_required === true ? "Yes" : item?.dsc_required === false ? "No" : "-",
                possession_type: item?.possessionType?.name  || "-",
                auction_start_time: item?.auction_start_time ? new Date(item.auction_start_time).toLocaleString("en-IN", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    }) : "-",
                auction_end_time: item?.auction_end_time ? new Date(item.auction_end_time).toLocaleString("en-IN", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    }) : "-",
                property_inspection_datetime: item?.property_inspection_datetime ? new Date(item.property_inspection_datetime).toLocaleString("en-IN", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: true,
                    }) : "-",
                auction_type: item?.auctionType?.name || "-",
                application_submission_date: item?.application_submission_date ? new Date(item.application_submission_date).toLocaleString("en-IN", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                }) : "-",
                time_extension: item?.time_extension || "-", 
                property_address: item?.property_address || "-",
                area_locality: item?.area_locality || "-",
                taluka: item?.taluka || "-",
                city_town: item?.city_town || "-",
                province_state: item?.province_state || "-",
                country: item?.country || "-",
                service_provider: item?.service_provider || "-",
                description:item?.description || "-",
                bank_name: item?.Bank?.bank_name || "-",
                branch_name: item?.Branch?.branch_name || "-",
                emd: item?.emd || "-",
                reserve_price: item?.reserve_price || "-",
                min_increment: item?.min_increment || "-",
                amount_outstanding: item?.amount_outstanding || "-",
                contact_name: item?.contact_name || "-",
                contact_number: item?.contact_number || "-",
              }
            })

            // Export to Excel
            const worksheet = XLSX.utils.json_to_sheet(dataToExport);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "NPA Properties");
            const fileName = "NPA Properties(Bank).xlsx";
            XLSX.writeFile(workbook, fileName);
            setLoading(false);
            dispatch(npaPropertiesList({ 
              status: cardStatus || "", 
              limit: 10, 
              asset_category: filterValues?.asset,
              property_type: filterValues?.property,
              possession_type: filterValues?.possession,
              city_town: filterValues?.city,
              reserve_price: filterValues?.reservePrice,
              search: filterValues?.search,  }))
        })
      }catch (error) {
        console.error("Error exporting data: ", error);
        setSnackbarMessage("Error exporting data: ", error);
        setSnackbarVariant("toast-success");
        setShowSnackbar(true);
        setLoading(false); // Disable loading state on error
      }
  };

  // IMport Handlers
    const [csvData, setCsvData] = useState("");
    const [importApiErr,setImportApiErr] = useState("")
    const [csvFileName, setCsvFileName] = useState("");

    const handleFileUpload = (event) => {
      const file = event.target.files[0];
      if (!file){
        setSnackbarMessage("No data available to Import");
        setSnackbarVariant("toast-success");
        setShowSnackbar(true);
        setLoading(false);
      }
      setCsvFileName(file?.name);
      setCsvData(file);
    }
  
    const handleSubmit = async () => {
      if (!csvData){
        setSnackbarMessage("Please upload a file before submitting.");
        setSnackbarVariant("toast-success");
        setShowSnackbar(true);
        setLoading(false);
      }
      try{
       setLoading(true);
       const result = await dispatch(reqToImportNpaProperties({properties_file:csvData})).unwrap()
       if (result){
        setSnackbarMessage(result?.msg || "Properties Imported Successfully!");
        setSnackbarVariant("toast-success");
        setShowSnackbar(true);
        dispatch(npaPropertiesList({
          status: cardStatus || "",
          page: currentPage,
          limit: limit?.value,
          asset_category: filterValues?.asset,
          property_type: filterValues?.property,
          possession_type: filterValues?.possession,
          city_town: filterValues?.city,
          reserve_price: filterValues?.reservePrice,
        })).then((res) => {
            setLoading(false);
            setCsvData("");
            setCsvFileName("");
            setCsvData("");
          })
       }
      }catch(error){
        setImportApiErr(error?.message)
        const errorMessage = error?.message || "Failed to Add Import Properties!";
        setSnackbarMessage(errorMessage);
        setSnackbarVariant("toast-danger");
        setLoading(false);
      }finally{
        handleCloseImportModal()
      }
    };

  return (
    <>
      <ToastContainer position="top-end" className="p-3">
        <Toast
          onClose={() => setShowSnackbar(false)}
          show={showSnackbar}
          delay={5000}
          autohide
          bg={snackbarVariant}
          className="position-fixed top-3 end-0 me-3 shadow-none"
        >
          <Toast.Body className="d-flex align-items-center gap-1 lh-sm">
            <CheckmarkBadge04Icon
              width={18}
              height={18}
              color="#28c76f"
              strokeWidth="2"
            />
            <span className="text-capitalize">{snackbarMessage}</span>
          </Toast.Body>
        </Toast>
      </ToastContainer>
      <Container fluid className="px-0">
        {/* Cards */}
        <div className="grid gap-4">
          {NpaPropertiesCard?.map((item, i) => (
            <DashboardCard
              key={i}
              totalUser={item?.total}
              title={item?.title}
              src={item?.src}
              alt={item?.title}
              active={item.status === cardStatus}
              status={item?.status}
              onClick={handleCardClick}
              classNameMain="g-col-4 g-col-xxl-3"
            />
          ))}
        </div>

        <div className="bg-white rounded-2 overflow-hidden common-shadow mt-5">
          <PropertyList
            isEdit={isEdit}
            data={properties}
            navigate={navigate}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            openDropdown={openDropdown}
            filterValues={filterValues}
            handleEditBtn={handleEditBtn}
            setFilterModal={setFilterModal}
            setFilterValues={setFilterValues}
            handleOpenImportModal={handleOpenImportModal}
            getCustomerActions={getCustomerActions}
            handleToggleDropdown={handleToggleDropdown}
            handleExportNpaProperties={handleExportNpaProperties}
          />

          {/* Pagination */}
          <div className="p-3 mx-1 d-flex flex-wrap align-items-center justify-content-between gap-4">
            <p className="custom-table-infotext ">
              Displaying {Math.min((currentPage - 1) * limit?.value + 1, total)}{" "}
              to {Math.min(currentPage * limit?.value, total)} of {total}
            </p>
            <div className="d-flex gap-4">
              {total > limit?.value && (
                <>
                  {/* <CreatableSelect
                      isClearable
                      options={recordsPerPageOptions}
                      value={limit}
                      onChange={handleChange}
                      placeholder="Select or create"
                      menuPortalTarget={document.body} // Render the menu at the body level
                      menuPlacement="top" // Display the options above the input
                      styles={{
                        control: (base) => ({
                          ...base,
                          width: "170px", // Fixed width for the input field
                        }),
                        menu: (base) => ({
                          ...base,
                          width: "170px", // Fixed width for the dropdown menu
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999, // Ensure it appears above everything
                        }),
                      }}
                    /> */}
                  <CommonPagination
                    totalItems={total}
                    setLimit={setLimit}
                    itemsPerPage={limit?.value}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </Container>

      {/* Delete POp-up */}
      <DeletePopup
        show={openDeletePropertyModal}
        onHide={() => setOpenDeletePropertyModal(false)}
        icon={
          <Delete02Icon
            width={48}
            height={48}
            color="#ff4c51"
            strokeWidth="1.5"
          />
        }
        title="Confirm Delete?"
        content="Are you sure you want to delete this campaign?"
        removeTitle="Cancel"
        onClickSave={handleConfirmDelete}
        disabled={isSubmitting}
        saveTitle={isSubmitting ? "Deleting..." : "Delete"}
      />
      {/* <ImportModal
        show={openImportModal}
        filterValues={filterValues}
        limit={limit}
        currentPage={currentPage}
        cardStatus={cardStatus}
        handleClose={handleCloseImportModal}
      /> */}
      {/* Import Modal */}
         <Modal
            show={openImportModal}
            // onHide={handleClose}
            centered
            dialogClassName="common-popup-dialog"
            contentClassName="common-popup-content"
            backdropClassName="common-popup-backdrop"
          >
            <Modal.Body className="common-popup-body">
              <div className="position-absolute end-0 z-2 bg-white rounded-1 cursor-pointer d-flex align-items-center justify-content-center common-popup-close-btn" onClick={handleCloseImportModal}>
                <Cancel01Icon width={16} height={16} color="#BCBBC1" strokeWidth="2.5"/>
              </div>
              <div className="text-center common-popup-heading" style={{ paddingRight: "20px", paddingLeft: "20px" }}>
                  <h2 className="text-center p-light mb-2">Import Properties</h2>
                    <Row className="text-start ">
                      <Col md={12} className="mt-4">
                        <CommonFormLabel title="Import File" />
                        <div className="border position-relative cursor-pointer custom-import-file rounded-2 overflow-hidden">
                          <div>{csvFileName ? csvFileName : "Choose file"}</div>
                          <span className="px-3 text-white d-flex align-items-center justify-content-center position-absolute top-0 bottom-0 end-0">Browse</span>
                          <input type="file" accept=".csv, .xlsx" onChange={handleFileUpload} className="position-absolute top-0 bottom-0 cursor-pointer start-0 end-0 opacity-0" />
                        </div>
                      </Col>
                    </Row>
        
                    <div className="text-center" style={{ width: "50%", margin: "0 auto" }}>
                      <CommonButton
                        title="Import"
                        type="submit"
                        className="w-100 btn-primary primary-shadow mt-5"
                        onClick={handleSubmit}
                        disabled={!csvData}
                      />
                      {importApiErr && (<div className="alert alert-danger mt-3"><p>{importApiErr}</p></div>)}
                    </div>
                  
                  </div>
                  <div className="d-flex align-items-center text-start justify-content-between mt-3">
                      <p className="cursor-pointer text-decoration-underline" onClick={(e) => downloadSampleCsvFile(e)}>Download Sample CSV File</p>
                      <OverlayTrigger 
                        placement="top" 
                        delay={{ show: 250, hide: 250 }}
                        overlay={<Tooltip id="button-tooltip">Please send your CSV file in the correct format as mentioned in Download Sample CSV file (including headers and values) to avoid any kind of rejections.</Tooltip>}>
                        <span className="cursor-pointer d-flex align-items-center justify-content-center">
                          <InformationCircleIcon width={19} height={19} color="#9F2F48" strokeWidth="2" />
                        </span>  
                      </OverlayTrigger>
                    </div>
            </Modal.Body>
          </Modal>

      {/* Filter POp-up */}
      <Modal
        size="lg"
        show={filterModal}
        onHide={() => setFilterModal(false)}
        centered
      >
        <Modal.Body className="mx-3 py-3">
          <div
            className="position-absolute end-0 z-2 bg-white rounded-1 cursor-pointer d-flex align-items-center justify-content-center common-popup-close-btn"
            onClick={() => setFilterModal(false)}
          >
            <Cancel01Icon
              width={16}
              height={16}
              color="#BCBBC1"
              strokeWidth="2.5"
            />
          </div>
          <div className="pb-3 border-bottom">
            {/* <h5 className="clear-btn-link">In this view show records</h5> */}
          </div>
          <Row className="g-4 pt-3">
            <Col xs={4}>
              <Select
                options={assetOptions}
                value={
                  filterValues?.asset
                    ? {
                        value: filterValues?.asset,
                        label: filterValues?.asset,
                      }
                    : null
                }
                isClearable
                placeholder="Asset category"
                className=""
                onChange={(e) => {
                  setFilterValues((val) => ({
                    ...val,
                    asset: e?.value || "",
                  }));
                  setCurrentPage(1);
                }}
              />
            </Col>
            <Col xs={4}>
              <Select
                options={propertyOptions}
                value={
                  filterValues?.property
                    ? {
                        value: filterValues?.property,
                        label: filterValues?.property,
                      }
                    : null
                }
                className=""
                isClearable
                placeholder="Property Type"
                onChange={(e) => {
                  setFilterValues((val) => ({
                    ...val,
                    property: e?.value || "",
                  }));
                  setCurrentPage(1);
                }}
              />
            </Col>
            <Col xs={4}>
              <Select
                options={possessionOptions}
                value={
                  filterValues?.possession
                    ? {
                        value: filterValues?.possession,
                        label: filterValues?.possession,
                      }
                    : null
                }
                className=""
                isClearable
                placeholder="Possession Type"
                onChange={(e) => {
                  setFilterValues((val) => ({
                    ...val,
                    possession: e?.value || "",
                  }));
                  setCurrentPage(1);
                }}
              />
            </Col>
            <Col xs={4}>
              <Select
                options={cityOptions}
                value={
                  filterValues?.city
                    ? { value: filterValues?.city, label: filterValues?.city }
                    : null
                }
                className=""
                isClearable
                placeholder="City"
                onChange={(e) => {
                  setFilterValues((val) => ({
                    ...val,
                    city: e?.value || "",
                  }));
                  setCurrentPage(1);
                }}
              />
            </Col>
            <Col xs={4}>
              <Select
                options={reservePriceOptions}
                value={
                  filterValues?.reservePrice
                    ? {
                        value: filterValues?.reservePrice,
                        label: filterValues?.reservePrice,
                      }
                    : null
                }
                className=""
                isClearable
                placeholder="Reserve Price"
                onChange={(e) => {
                  setFilterValues((val) => ({
                    ...val,
                    reservePrice: e?.value || "",
                  }));
                  setCurrentPage(1);
                }}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="mx-3 py-3">
          <Button
            className="p-0 m-0 clear-btn-link fw-medium"
            type="button"
            variant="link"
            onClick={() => {
              setFilterValues({
                asset: "",
                property: "",
                possession: "",
                city: "",
                reservePrice: "",
              });
              setFilterModal(false);
            }}
          >
            Clear all filters
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Dashboard;
